module.exports = __webpack_public_path__ + "img/talent-hunt.d85160a2.png";